import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import useOrderMicrosoftFinanceAndOperationsSyncState
  from '~/orders/integrations/microsoft-finance-and-operations/use-order-microsoft-finance-and-operations-sync-state';
import OrderIntegrationIcon from '~/orders/integrations/order-integration-icon';
import React, { useCallback } from 'react';
import { Link, makeStyles } from '~/lib/bn-material-ui';
import BnCopyToClipboard from '~/common/bn-copy-to-clipboard';
import { syncOrderIntegration } from '~/orders/dialogs/order-planner-dialog/context/orders-dialog-sync-integration';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'inline-flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
  },
  retry: {
    textDecoration: 'underline',
    marginLeft: '1rem',
  },
  message: {
    fontStyle: 'italic',
    textOverflow: 'ellipsis',
    color: theme.palette.green[20],
  },
  'not-synced': {
    color: theme.palette.gray[60],
  },
  error: {
    color: theme.palette.red[20],
  },
}));

export default function MicrosoftFinanceAndOperationsState({ orderHref }) {
  const styles = useStyles();
  const { entity: order } = useSirenEntity({ href: orderHref });
  const { loading, message, state, fAndOIntegration } = useOrderMicrosoftFinanceAndOperationsSyncState({ order }) || {};
  const [retrying, setRetrying] = React.useState(false);

  const retryClick = useCallback(async () => {
    const mounted = true;
    setRetrying(true);
    await syncOrderIntegration(order);
    if (mounted) {
      setRetrying(false);
    }
  }, [order]);

  if (!order || loading) {
    return null;
  }
  const showError = state === 'error';
  const showRetry = !retrying && showError && fAndOIntegration?.getAction('sync-order');
  const messageClassnames = [styles[state], styles.message].filter(Boolean).join(' ');
  return (
    <div className={styles.container}>
      <OrderIntegrationIcon state={state}/>
      { showError
        ? <BnCopyToClipboard className={messageClassnames} text={message}>{message}</BnCopyToClipboard>
        : <span className={messageClassnames}>{message}</span>
      }
      {showRetry && <Link onClick={retryClick} className={`${styles.error} ${styles.retry}`} href='#'>Retry</Link>}
      {retrying && <span className={styles.error}>Retrying...</span>}
    </div>
  );
}
